import React, { Component } from "react";
import PropTypes from "prop-types";
import postMessageToParent from "../utilities/postMessage";
import handleMessage from "../utilities/messageListener";

class MessagePoster extends Component {

  componentDidMount() {
    window.addEventListener("message", handleMessage);
    window.addEventListener("resize", postMessageToParent);
  }

  componentWillUnmount() {
    window.removeEventListener("message", handleMessage);
    window.removeEventListener("resize", postMessageToParent);
  }

  render() {
    const { children } = this.props;
    return <div onLoad={postMessageToParent}>{children}</div>;
  }
}

MessagePoster.propTypes = {
  children: PropTypes.node.isRequired
};

export default MessagePoster;
